export default __webpack_public_path__ + "static/media/scholarships_bg.5e90ddff.jpg";